<div class="confirm-modal ig-modal input-modal overflow-x-hidden">
    <div class="close-button">
        <mat-icon (click)="close()">clear</mat-icon>
    </div>
    <div class="title">{{ data.inputModalTitle }}</div>
    <div class="mt-3">
        <ig-field [label]="data.inputModalHelpText" [control]="form.get('text')">
        </ig-field>
        <div class="mat-mdc-form-field-hint !text-red-600 !mt-1" *ngIf="form.get('text')?.touched && form.get('text')?.invalid">
            <span *ngIf="form.get('text')?.errors?.required">Public URL is required.</span>
            <span *ngIf="form.get('text')?.errors?.url">Enter a valid URL.</span>
            <span *ngIf="form.get('text')?.errors?.protocol">URL must start with http:// or https://</span>
        </div>
    </div>
    <mat-dialog-actions align="end">
        <ig-button class="btn-primary" size="md" #confirmButton [isAsync]="data.isAsync" (trigger)="confirm($event)" theme
            [disabled]="form.invalid || !isChanged">{{
            data.inputModalConfirmButtonText }}</ig-button>        
        <div class="cancel-btn ml-4" *ngIf="!confirmButton.isLoading" (click)="close()">
            {{ data.inputModalCancelButtonText }}
        </div>
    </mat-dialog-actions>
</div>